import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const utmApi = createApi({
  reducerPath: "utm",
  baseQuery: fetchBaseQuery({
    baseUrl: ``,
  }),
  endpoints: (builder) => {
    return {
      postUtmDetails: builder.mutation({
        query: (body) => {
          return {
            url: `/api/utm`,
            method: "POST",
            body,
          };
        },
      }),
    };
  },
});

export const { usePostUtmDetailsMutation } = utmApi;
export { utmApi };
